export const SET = "REMOTE_CONFIG/SET";
